// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".constructor[data-v-fdbad174]{z-index:1}.constructor-btn[data-v-fdbad174]{display:block;margin:25px auto 0;background-color:#463a3c;opacity:.8;color:#ddd;font-size:18px;border:0;border-radius:5px;padding:15px;cursor:pointer;transition:all .3s ease}.constructor-btn[data-v-fdbad174]:hover{opacity:1}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
